import React from "react";
import {TermsOfService} from "../components/TermsOfService";
import {Helmet} from "react-helmet-async";

export default function TermsOfServicePage() {
    return (
        <>
            <Helmet prioritizeSeoTags>
                <title>Terms of Service — Codebuddy AI</title>
                <link rel="canonical" key="link-canonical" href="https://www.codebuddy.ca/terms-of-service"/>
                <meta property="og:title" name="og:title" key="og:title" content="Terms of Service — Codebuddy AI"/>
                <meta property="og:url" name="og:url" key="og:url" content="https://www.codebuddy.ca/terms-of-service"/>
            </Helmet>
            <TermsOfService/>
        </>
    );
}